import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Navigation from './components/navigation';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Calendar from "./components/Calendar";
import Profile from "./components/Profile";
import { setAdminStatus } from "./redux/slices/isAdminSlice"; // Импортируем действие для обновления состояния
import UnderDevelopment from "./components/UnderDevelopment";
import Victories from "./components/Victories"; // Новый компонент
import PaymentScreen from "./components/PaymentScreen"; // Импортируем новый компонент
import LoaderInside from './components/LoaderInside'; // Импортируем новый лоадер
import config from "./config";
import { setUserData } from "./redux/slices/userSlice";
import RatingTable from "./components/RatingTable";
import Sidebar from "./components/Sidebar"; // Импортируем новый компонент
import TaskDisplay from './components/TaskDisplay'; // Импортируем новый компонент
import SuggestionsPage from './components/SuggestionsPage';
import TechnicalIssuePage from './components/TechnicalIssuePage';
import Upgrade from "./components/Upgrade";
import UpgradeDetail from "./components/UpgradeDetail";
import DetailPage from "./components/DetailPage";
import GuideDetailPage from "./components/GuideDetailPage";
import OnboardingFlow from "./components/onboarding/OnboardingFlow"; // Импортируем компонент предрегистрации


import axios from "axios";
import './scss/all.scss'

const App = () => {
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isNewUser, setIsNewUser] = useState(false); // Состояние для новых пользователей
  const dispatch = useDispatch(); // Используем dispatch для изменения состояния в Redux

  useEffect(() => {
    // Проверяем, доступен ли объект Telegram Web App
    if (window.Telegram && window.Telegram.WebApp) {
      // Инициализируем Telegram Web App
      window.Telegram.WebApp.ready();
      // Получаем initData
      const initData = window.Telegram.WebApp.initData;
      // Отправляем initData на сервер для проверки
      axios
        .post(`${config.API_BASE_URL}/auth`, { initData })
        .then((response) => {
          const fetchedUser = response.data.user;
          setUser(fetchedUser);
          // Проверяем, является ли пользователь новым
          setIsNewUser(fetchedUser.isNew);
          // Сохраняем все данные пользователя в Redux
          dispatch(setUserData({
            telegramId: fetchedUser.id,
            username: fetchedUser.username,
            firstName: fetchedUser.first_name,
            lastName: fetchedUser.last_name,
            role: fetchedUser.role,
            gender: fetchedUser.gender,
            isNew: fetchedUser.isNew
          }));
          // Устанавливаем админский статус
          dispatch(setAdminStatus(fetchedUser.role === 'superuser'));
        })
        .catch(() => {
          setError("Ошибка авторизации. Проверьте настройки.");
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setError("Telegram Web App недоступен. Откройте приложение внутри Telegram.");
      setIsLoading(false);
    }
  }, [dispatch]);


  if (isLoading) {
    return (
      <div className="main-load">
        <LoaderInside />
      </div>); // Отображаем новый лоадер во время загрузки
  }

  if (error) {
    return <PaymentScreen />;
  }

  // Если пользователь новый, показываем страницу предрегистрации
  if (user && isNewUser) {
    return <OnboardingFlow />;
  }

  return (
    <Router>
      <div>
        <Routes>
          {/* Главная страница */}
          <Route
            path="/"
            element={user ? (
              <div className="main">
                <div className="main-content">
                  <Calendar selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
                  <Sidebar selectedDate={selectedDate} />
                  <TaskDisplay selectedDate={selectedDate} />
                </div>
              </div>
            ) : (
              <PaymentScreen />
            )}
          />

          {/* Профиль */}
          <Route
            path="/profile"
            element={user ? (
              <div className="main">
                <div className="main-content">
                  <Profile />
                </div>
              </div>
            ) : (
              <Navigate to="/no-access" />
            )}
          />

          {/* Победы */}
          <Route
            path="/victories"
            element={user ? (
              <div className="main">
                <div className="main-content">
                  <Victories />
                </div>
              </div>
            ) : (
              <Navigate to="/no-access" />
            )}
          />

          {/* Рейтинг */}
          <Route
            path="/rating"
            element={user ? (
              <div className="main">
                <div className="main-content">
                  <RatingTable />
                </div>
              </div>
            ) : (
              <Navigate to="/no-access" />
            )}
          />

          {/* Предложения */}
          <Route
            path="/suggestions"
            element={user ? (
              <div className="main">
                <div className="main-content">
                  <SuggestionsPage />
                </div>
              </div>
            ) : (
              <Navigate to="/no-access" />
            )}
          />

          {/* Технические проблемы */}
          <Route
            path="/technical-issue"
            element={user ? (
              <div className="main">
                <div className="main-content">
                  <TechnicalIssuePage />
                </div>
              </div>
            ) : (
              <Navigate to="/no-access" />
            )}
          />

          {/* Маршруты для обучающих материалов */}
          <Route
            path="/upgrade"
            element={user ? (
              <div className="main">
                <div className="main-content">
                  <Upgrade />
                </div>
              </div>
            ) : (
              <Navigate to="/no-access" />
            )}
          />

          {/* Маршрут для деталей раздела */}
          <Route
            path="/upgrade/:title"
            element={user ? (
              <div className="main">
                <div className="main-content">
                  <UpgradeDetail />
                </div>
              </div>
            ) : (
              <Navigate to="/no-access" />
            )}
          />

          {/* Маршрут для деталей контента (не гайд) */}
          <Route
            path="/upgrade/:title/detail/:buttonText"
            element={user ? (
              <div className="main">
                <div className="main-content">
                  <DetailPage />
                </div>
              </div>
            ) : (
              <Navigate to="/no-access" />
            )}
          />

          {/* Маршрут для деталей гайда */}
          <Route
            path="/upgrade/:title/guide/:buttonText"
            element={user ? (
              <div className="main">
                <div className="main-content">
                  <GuideDetailPage />
                </div>
              </div>
            ) : (
              <Navigate to="/no-access" />
            )}
          />

          {/* Служебные маршруты */}
          <Route
            path="/soon"
            element={user ? <div className="main-load"><UnderDevelopment /></div> : <Navigate to="/no-access" />}
          />
          <Route path="/no-access" element={<div>Нет доступа</div>} />
        </Routes>
        <Navigation />
      </div>
    </Router>
  );
};

export default App;
